import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { ITradesGasData, ITradesGasHistoryData } from "./gasData.types"
import { TradesGasData, TradesGasHistoryData } from "./gasData"
import {
  GetGasTradesHistoryQuery,
  GetGasTradesQuery,
} from "@/api/hasura/generated/graphql"
import { dayjsOrNull, numberOfDaysInInterval } from "@/helpers/dateHelper"
import dayjs from "dayjs"

export type ITradesGasDataRaw = GetGasTradesQuery["GasTrades"][0]
export type ITradesGasHistoryDataRaw =
  GetGasTradesHistoryQuery["GasTradesHistory"][0]

const computeTotalVolume = (
  volume?: number | null,
  dateFrom?: Date | null,
  dateTo?: Date | null,
) => {
  if (volume) {
    return volume * numberOfDaysInInterval(dayjs(dateFrom), dayjs(dateTo))
  } else return 0
}

export const TradesGasDataParser: IParser<ITradesGasData, ITradesGasDataRaw> = {
  toDomain(data: ITradesGasDataRaw): ITradesGasData {
    try {
      return new TradesGasData(
        data.id,
        dayjsOrNull(data.Date),
        data.Period ?? null,
        data.Index ?? null,
        data.Price ?? null,
        data.Volume ?? null,
        computeTotalVolume(data.Volume, data.Date_From, data.Date_To),
        dayjsOrNull(data.Date_From),
        dayjsOrNull(data.Date_To),
        data.CounterParty ?? null,
        data.Trader ?? null,
        data.Notes ?? null,
        dayjsOrNull(data.ConfirmReceived),
        dayjsOrNull(data.ConfirmSignedDate),
        data.ConfirmSignedBy ?? null,
        data.Locked,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export const TradesGasHistoryDataParser: IParser<
  ITradesGasHistoryData,
  ITradesGasHistoryDataRaw
> = {
  toDomain(data: ITradesGasHistoryDataRaw): ITradesGasHistoryData {
    try {
      return new TradesGasHistoryData(
        data.id,
        data.gas_trade_id,
        dayjsOrNull(data.Date),
        data.Period ?? null,
        data.Index ?? null,
        data.Price ?? null,
        data.Volume ?? null,
        computeTotalVolume(data.Volume, data.Date_From, data.Date_To),
        dayjsOrNull(data.Date_From),
        dayjsOrNull(data.Date_To),
        data.CounterParty ?? null,
        data.Trader ?? null,
        data.Notes ?? null,
        dayjsOrNull(data.ConfirmReceived),
        dayjsOrNull(data.ConfirmSignedDate),
        data.ConfirmSignedBy ?? null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
